import { validateRequired } from '../../../helpers/formValidation'
import { PublishMaterialForm } from './typings'

const validatePublishMaterialForm = ({
  values,
  errors,
  field
}: PublishMaterialForm): Record<string, string> => {
  let formErrors: Record<string, string> = { ...errors }
  const {
    coachingCentreId,
    branchId,
    batchId,
    courseId,
    subjectId,
  } = values || {}

  switch (field) {
    case 'instituteName':
      formErrors['instituteName'] = validateRequired(coachingCentreId)
      break
    case 'branchName':
      formErrors['branchName'] = validateRequired(branchId)
      break
    case 'coureName':
      formErrors['coureName'] = validateRequired(courseId)
      break
    case 'batchName':
      formErrors['batchName'] = validateRequired(batchId)
      break
    case 'subjectName':
      formErrors['subjectName'] = validateRequired(subjectId)
      break

    default:
      formErrors['instituteName'] = validateRequired(coachingCentreId)
      formErrors['branchName'] = validateRequired(branchId)
      formErrors['coureName'] = validateRequired(courseId)
      formErrors['batchName'] = validateRequired(batchId)
      formErrors['subjectName'] = validateRequired(subjectId)
  }

  return formErrors
}

export default validatePublishMaterialForm
